import {
  fetchAndParsePricesCsv,
  getPriceRangeFromPeriod,
  PERIOD,
  calcYield,
} from "@glitchful-dev/sol-apy-sdk";
import type { Yield } from "@glitchful-dev/sol-apy-sdk";
import { captureException } from "@sentry/nextjs";

const MARINADE_BACKUP =
  "https://thru.marinade.finance/glitchful-dev/sol-stake-pool-apy/master/db/marinade.csv";

export async function fetchGlitchfulStakeApy(
  url: string = MARINADE_BACKUP,
  period: PERIOD = PERIOD.DAYS_30
): Promise<Yield | null> {
  try {
    const prices = await fetchAndParsePricesCsv(url);
    const priceRange = getPriceRangeFromPeriod(prices, period);
    if (!priceRange) {
      return null;
    }

    return calcYield(priceRange);
  } catch (err) {
    captureException(err);
    return null;
  }
}
